import {
  Control,
  Controller,
  FieldValues,
  Path,
  PathValue,
  UseFormSetValue,
  UseFormTrigger,
  useController,
} from 'react-hook-form';
import { StateSelect } from '../form/locationDropdowns';

const FormStateAutocomplete = <R extends FieldValues>({
  name,
  control,
  setValue,
  countryCode,
  trigger,
}: {
  name: Path<R>;
  control: Control<R>;
  setValue: UseFormSetValue<R>;
  countryCode?: string;
  fieldsToClear: Path<R>[];
  trigger: UseFormTrigger<R>;
}) => {
  const {
    fieldState: { isTouched },
  } = useController({ name, control });

  const onChange = (newValue: string) => {
    setValue(name, newValue as PathValue<R, Path<R>>);
    if (isTouched) trigger(name, { shouldFocus: true });
  };

  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { onBlur, value }, fieldState: { error } }) => (
        <StateSelect
          value={value}
          onBlur={onBlur}
          countryCode={countryCode}
          onChange={onChange}
          error={!!error}
        />
      )}
    />
  );
};

export default FormStateAutocomplete;
